var pathRoot = 'http://lookbook.normakamali.com/'

function swapImg(file) { document.getElementById('viewer').src=pathRoot+file+'.jpg' }
function viewerOff() { document.getElementById('viewer').style.left="-9999px"; document.getElementById('viewer').style.visibility="hidden"; }
function viewerOn() { document.getElementById('viewer').style.left="0px"; document.getElementById('viewer').style.visibility="visible"; }
function loadSwap(loadFile) {
	var main = document.getElementById('mainVid'),
	    playa2 = document.getElementById('player'),
	    viewa2 = document.getElementById('viewer');

	if (loadFile == '' || loadFile==undefined) {loadFile = main.getAttribute('data-path')+'/thumbs/'+main.getAttribute('data-file')};

	main.click();


	if ((' ' + main.className + ' ').indexOf(' vidBtn ') > -1) {
		swapImg(loadFile);
		viewerOn();
		playa2.pause();
//		playa2.currentTime=0;
		viewa2.style.cursor="pointer";
		viewa2.onclick = function() {
			main.click();
			viewerOff();
			viewa2.style.cursor="default";
		}
	}

}

if (!!document.createElement('video').play) {
	window.addEventListener('load',function() {
		var playa = document.getElementById('player');
		var viewa = document.getElementById('viewer');

		var vv = document.querySelectorAll('button.vidBtn');
		for(i = 0; i<vv.length; i++) {
			vv[i].addEventListener('click',function(e) {

				/* kludge to get Safari to behave... */
				var targ = e.target;
				if (targ.tagName != 'BUTTON') { targ = targ.parentNode; }

//				playa.poster = pathRoot+'/thumbs/blank.png';
				if (playa.canPlayType("video/mp4") == 'maybe' || playa.canPlayType("video/mp4") == 'probably') { 
					playa.src = pathRoot+targ.getAttribute('data-path')+'/videos/'+targ.getAttribute('data-file')+'.mp4';
				} else if (playa.canPlayType("video/webm") == 'maybe' || playa.canPlayType("video/webm") == 'probably') { 
					playa.src = pathRoot+targ.getAttribute('data-path')+'/videos/'+targ.getAttribute('data-file')+'.webm';
				}
				playa.poster = pathRoot+targ.getAttribute('data-path')+'/thumbs/'+targ.getAttribute('data-file')+'.jpg'; 
				playa.load();
				viewerOff();
				playa.play();
			},true);
  		}
		
		var vi = document.querySelectorAll('button.imgBtn');
		for(i = 0; i<vi.length; i++) {
			vi[i].addEventListener('click',function(e) {

				/* kludge to get Safari to behave... */
				var targ = e.target;
				if (targ.tagName != 'BUTTON') { targ = targ.parentNode; }

				viewa.src = pathRoot+targ.getAttribute('data-path')+'/thumbs/'+targ.getAttribute('data-file')+'.jpg'
				viewerOn();
				document.getElementById('player').pause();
			},true);
  		}
		

//      window.alert("Script running!");
      loadSwap();
/*
      var main = document.getElementById('mainVid')

	  if (loadFile == '' || loadFile==undefined) {loadFile = main.getAttribute('data-path')+'/thumbs/'+main.getAttribute('data-file')};
	  main.click();
	  if ((' ' + main.className + ' ').indexOf(' vidBtn ') > -1) {
		swapImg(loadFile);
		viewerOn();
		playa2.pause();
//		playa2.currentTime=0;
		viewa2.style.cursor="pointer";
		viewa2.onclick = function() {
			main.click();
			viewerOff();
			viewa2.style.cursor="default";
		}
	  }
*/
    }, true);
}